const configApp = {
  academyDomain: 'https://academia.test.vidroop.com',
  apiKeyTinyMce: 'nmmuxa1oi0rlug1hougubvrgge2hhd73ju9jq5thrlvy62gi',
  apiUrl: 'https://api.test.vidroop.com',
  apiVersion: 'v1',
  appDomain: 'https://aula.test.vidroop.com',
  authCallbackUrl: 'https://aula.test.vidroop.com/login',
  authClientId: 'DkhQUUlS33GJVhs8RIqBzFsy9USfwsfB',
  authDomain: 'dev-aws-vidroop.eu.auth0.com',
  pdfGeneratorDomain: 'https://pdfgenerator.test.vidroop.com/v1/invoice',
  stripePublicKey: 'pk_test_51IsF0cCA8lC7iDvSEsoLJHabyVI0yhFHG0pAgZkjv25ILQujdmFcGGO0jAoZiXeR35kWINTwcH0idrci5oYmFtYb00NIEswIbf',
  marketPlaceDomain: 'https://tienda.test.vidroop.com/academia'
}

export default configApp
